import React, { useEffect } from 'react'
import { withRouter } from 'react-router'

import { WidgetContext } from 'src/modules/App/WidgetContext'
import { injectIntl } from 'react-intl'
import DefaultSvg from './DefaultSvg/DefaultSvg'
import { updateDocumentTitle } from 'src/utils/helpers'
import { Text, Stack, Box, Flex, Image, Center } from '@chakra-ui/react'
import intlMessages from './translations'
import './Welcome.module.less'

const Welcome = ({ openSidebar, welcomeScreen, setCurrentlyOpenFeature, isWidget, intl }) => {
  useEffect(() => {
    openSidebar()
    setCurrentlyOpenFeature('welcome')
    if (!isWidget) {
      updateDocumentTitle(
        (welcomeScreen && welcomeScreen.title) || intl.formatMessage(intlMessages.welcomeMessage),
      )
    }
  }, [])

  return (
    <Stack h={'100%'} display={{ base: 'none', desktop: 'flex' }}>
      <Flex direction={'column'} flex={1} justify={'center'}>
        <Flex direction={'row'} align={'flex-start'}>
          <Center w={'100%'}>
            <Box maxW='540px'>
              <Text variant='secondary' fontSize={'56px'} fontWeight={'bold'}>
                {welcomeScreen.title || intl.formatMessage(intlMessages.welcomeMessage)}
              </Text>
              <Text variant='secondary' fontSize={'24px'} opacity={0.5} mt={'40px'}>
                {welcomeScreen.subtitle || intl.formatMessage(intlMessages.welcomeDescription)}
              </Text>
            </Box>
          </Center>
          <Center w={'100%'}>
            {welcomeScreen.image ? (
              <Image w={'100%'} src={welcomeScreen.image} alt='bg' />
            ) : (
              <DefaultSvg
                backgroundFontColor={'var(--chakra-colors-secondary)'}
                actionColor={'var(--chakra-colors-accent)'}
              />
            )}
          </Center>
        </Flex>
      </Flex>
    </Stack>
  )
}
const WelcomeContext = props => (
  <WidgetContext.Consumer>{context => <Welcome {...props} {...context} />}</WidgetContext.Consumer>
)

export default withRouter(injectIntl(WelcomeContext))
